<template>
  <div v-if="isOpen">
    <div class="modal fade" role="dialog" ref="extraModal">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-body repricing-modal">
            <div class="row">
              <div class="col-sm-12">
                <div class="d-flex justify-between items-center">
                  <h4>Post Booking Extra Services</h4>
                  <button
                    type="button"
                    class="close btn-close-modal"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="closeModal()"
                  >
                    <i class="ic-close"></i>
                  </button>
                </div>
              </div>
              <div class="col-sm-12">
                <form @submit.prevent="onSubmit">
                  <div class="form-group">
                    <label class="required">Name</label>
                    <v-select
                      class="v-search-select"
                      :class="{
                        'field-error':
                          isSubmitted && !$v.modelBooking.name.required,
                      }"
                      placeholder=""
                      label="label"
                      v-model="modelBooking.name"
                      @input="clearModelBooking()"
                      :options="bookingOption"
                      :clearable="true"
                      :searchable="true"
                      :filterable="true"
                      :reduce="(option) => option.value"
                    ></v-select>
                    <small
                      class="form-text sts-danger"
                      v-if="isSubmitted && !$v.modelBooking.name.required"
                      style="display: block"
                    >
                      Name is required
                    </small>
                  </div>
                  <div class="form-group" v-if="modelBooking.name && showQty">
                    <template>
                      <label class="required">Quantity</label>
                      <span class="sts-danger" v-if="showMinOnQty">(Min.)</span>
                    </template>
                    <input
                      type="text"
                      class="form-control numbers-only"
                      :class="{
                        'field-error':
                          isSubmitted && $v.modelBooking.qty.$error,
                      }"
                      name="quantity"
                      v-model="modelBooking.qty"
                      placeholder="Enter quantity"
                    />
                    <small
                      class="form-text sts-danger"
                      v-if="isSubmitted && $v.modelBooking.qty.$error"
                      style="display: block"
                    >
                      {{
                        !$v.modelBooking.qty.minValue
                          ? "Minimum quantity must be 1"
                          : "Quantity is required"
                      }}
                    </small>
                  </div>
                  <div class="form-group" v-if="modelBooking.name">
                    <template>
                      <label class="required">Buying Rate</label>
                      <span style="color: #777">(in local currency)</span>
                    </template>
                    <currency-input
                      class="form-control"
                      :class="{
                        'field-error':
                          isSubmitted && !$v.modelBooking.buyingRate.required,
                      }"
                      autocomplete="off"
                      placeholder="Enter buying rate"
                      name="buying"
                      v-model="modelBooking.buyingRate"
                      :allow-negative="false"
                      :currency="null"
                      :locale="currencyLocale"
                      :precision="currencyPrecision"
                    />
                    <small
                      class="form-text sts-danger"
                      v-if="isSubmitted && !$v.modelBooking.buyingRate.required"
                      style="display: block"
                    >
                      Buying rate is required
                    </small>
                  </div>
                  <div class="form-group" v-if="modelBooking.name">
                    <template>
                      <label class="required">Selling Rate</label>
                      <span style="color: #777">(in local currency)</span>
                    </template>
                    <currency-input
                      class="form-control"
                      :class="{
                        'field-error':
                          isSubmitted && $v.modelBooking.sellingRate.$error,
                      }"
                      autocomplete="off"
                      placeholder="Enter selling rate"
                      name="selling"
                      v-model="modelBooking.sellingRate"
                      :allow-negative="false"
                      :currency="null"
                      :locale="currencyLocale"
                      :precision="currencyPrecision"
                    />
                    <small
                      class="form-text sts-danger"
                      v-if="isSubmitted && $v.modelBooking.sellingRate.$error"
                      style="display: block"
                    >
                      Selling rate is required
                    </small>
                  </div>
                  <div class="d-flex justify-end gap-10 items-center">
                    <button type="reset" class="btn btn-cancel">Reset</button>
                    <button type="submit" class="btn btn-submit">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <loader :content="msg" :visible="isLoading" />
  </div>
</template>
<script>
import { PostBookingItem } from "@/models/constants";
import { required, minValue } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      isOpen: false,
      isLoading: false,
      msg: "Please wait",
      isSubmitted: false,
      modelBooking: {
        name: "",
        qty: null,
        buyingRate: null,
        sellingRate: null,
      },
      bookingOption: [],
      currencyLocale: "en-US",
      currencyPrecision: 2,
    };
  },
  validations() {
    const v = {
      modelBooking: {
        name: { required },
        qty: this.validationQty,
        buyingRate: { required },
        sellingRate: { required },
      },
    };

    return v;
  },
  computed: {
    showQty() {
      return (
        this.modelBooking.name !== PostBookingItem.fareParkingLabel &&
        this.modelBooking.name !== PostBookingItem.fareTollLabel
      );
    },
    showMinOnQty() {
      return (
        this.modelBooking.name === PostBookingItem.waitingTimeLabel ||
        this.modelBooking.name === PostBookingItem.overtimeLabel
      );
    },
    validationQty() {
      return !this.showQty ? {} : { required, minValue: minValue(1) };
    },
  },
  created() {
    this.$eventBus.$on("FormPostBooking", this.initialize);
  },
  beforeDestroy() {
    this.$eventBus.$off("FormPostBooking");
  },
  methods: {
    initialize(bookingOption) {
      this.isLoading = true;
      this.isOpen = true;
      this.bookingOption = bookingOption;
      this.modelBooking = {
        name: "",
        qty: null,
        buyingRate: null,
        sellingRate: null,
      };
      setTimeout(() => {
        $(this.$refs.extraModal).modal({
          backdrop: "static",
          keyboard: false,
        });
        this.isLoading = false;
      }, 1000);
    },
    clearModelBooking() {
      this.modelBooking = {
        ...this.modelBooking,
        qty: null,
        buyingRate: null,
        sellingRate: null,
      };
    },
    onSubmit() {
      this.isSubmitted = true;
      this.$v.modelBooking.$touch();
      if (this.$v.modelBooking.$error) {
        this.$nextTick(() => this.$helper.focusToFieldError());
        return;
      }

      this.modelBooking = {
        ...this.modelBooking,
        qty:
          this.modelBooking.name === PostBookingItem.fareParkingLabel ||
          this.modelBooking.name === PostBookingItem.fareTollLabel
            ? 1
            : this.modelBooking.qty,
      };

      this.$emit("submit", "post-booking", this.modelBooking);
      this.closeModal();
    },
    closeModal() {
      this.isOpen = false;
      this.isSubmitted = false;
      $(this.$refs.extraModal).modal("hide");
    },
  },
  updated() {
    this.$helper.numbersOnly();
  },
};
</script>
<style scoped>
.modal-body.repricing-modal {
  padding: 15px 20px;
}
.btn.btn-submit {
  background: #4fb848;
  font-size: 0.8667rem;
  border-radius: 5px;
  border: transparent;
  font-weight: 900;
  -webkit-box-shadow: 0px 2px 8px -5px #4c4c4c;
  -moz-box-shadow: 0px 2px 8px -5px #4c4c4c;
  box-shadow: 0px 2px 8px -5px #4c4c4c;
  color: #fff;
  padding: 10px 20px;
  text-transform: uppercase;
  outline: none;
}
.btn.btn-cancel {
  background: #a0a0a0;
  font-size: 0.8667rem;
  border-radius: 5px;
  border: transparent;
  font-weight: 900;
  -webkit-box-shadow: 0px 2px 8px -5px #4c4c4c;
  -moz-box-shadow: 0px 2px 8px -5px #4c4c4c;
  box-shadow: 0px 2px 8px -5px #4c4c4c;
  color: #fff;
  padding: 10px 20px;
  text-transform: uppercase;
  outline: none;
}
.btn.btn-submit:hover {
  background: #339c2b;
}
.btn.btn-cancel:hover {
  background: #888888;
}
.gap-10 {
  gap: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/FormPostBooking.vue